import { call, put, cancel, select } from 'redux-saga/effects';

import { getSavedFilingPeriodByIdRequest } from '@actions/savedFilingPeriod';
import {
  fetchProcessingAggregatesStart,
  fetchProcessingAggregatesStop,
  fetchProcessingAggregatesSuccess,
  getStandardTemplateAggregatesRequest,
  getStandardTemplatesRequest,
} from '@actions/standardTemplate';
import { checkStandardTemplateAggregateJobsRunning } from '@api/standardTemplate';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';
import {
  aggregatesSelector,
  selectedStandardTemplateSelector,
} from '@store/selectors/standardTemplate';

// TODO: This can be simplified if we isolate the aggregates functionality. At the moment the processing state for aggregates is controlled from standard template
export const processingAggregatesRequestSaga = function* ({ payload }) {
  try {
    const { processingAggregates, isDataProcessingAggregate } = yield call(
      checkStandardTemplateAggregateJobsRunning,
      payload
    );

    const selectedStandardTemplate = yield select(selectedStandardTemplateSelector);
    const currentlyProcessing = selectedStandardTemplate.isDataProcessingAggregate;
    const currentAggregates = yield select(aggregatesSelector);
    const currentStandardTemplateId = currentAggregates.results[0].standardTemplate.id;
    /*
     * Because we are polling it is possible that the user is on a different standard template thant the one that kicked off polling.
     * If that is the case we abort and wait for the next poll.
     */
    if (currentStandardTemplateId !== payload) yield cancel();

    /* Terminate early if no aggregates were previously processing and no aggregates are currently loading */
    if (!currentlyProcessing && !isDataProcessingAggregate) yield cancel();

    let shouldUpdateAggregate = false;

    /*
     * If we have processing aggregates, then run through the current aggregates and update.
     */
    if (isDataProcessingAggregate) {
      const results = currentAggregates.results.map(row => {
        const runningJob = processingAggregates.includes(row.id);
        if (!runningJob && row.runningJob) shouldUpdateAggregate = true;

        return {
          ...row,
          standardTemplate: {
            ...row.standardTemplate,
            isDataProcessingAggregate,
          },
          runningJob,
        };
      });

      /*
       * If we only have aggregates entering loading states we can just update the aggregates with the new state
       */
      if (!shouldUpdateAggregate) {
        yield put(
          fetchProcessingAggregatesSuccess({
            isDataProcessingAggregate,
            aggregates: {
              ...currentAggregates,
              results,
            },
          })
        );
      }
    }

    /*
     * If any aggregates that were in a loading state come out or if we were processing and now no rows are processing,
     * we have to reload aggregates to get the values after processing
     */
    if (!isDataProcessingAggregate || shouldUpdateAggregate) {
      yield put(fetchProcessingAggregatesStop());
      yield put(getStandardTemplateAggregatesRequest(payload));
      yield put(fetchProcessingAggregatesStart(payload)); // TODO: Add this to onSuccess of getStandardTemplateAggregatesRequest.
    }

    /*
     * If we were busy processing, but all aggregates are now done, we have to reload the standardTemplate and savedFilingPeriod to get a new status
     */
    if (!isDataProcessingAggregate && currentlyProcessing) {
      const selectedFilingPeriod = yield select(selectedFilingPeriodSelector);
      yield put(getStandardTemplatesRequest({ savedFilingPeriod: selectedFilingPeriod.id }));
      yield put(getSavedFilingPeriodByIdRequest(selectedFilingPeriod.id));
    }
  } catch (error) {
    // Do nothing
  }
};
